import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { SliceCaseReducers } from '@reduxjs/toolkit/src/createSlice';
import { useEffect } from 'react';

import { useDispatch } from 'react-redux';

import SiteApi from '../../Api/SiteApi/SiteApi';
import Money from '../../Api/Types/Money';

import { getUserCurrency } from '../../utils/currency';
import { formatCurrency } from '../../utils/formatCurrency';
import { useGlobalStoreSelector } from '../GlobalStore';

export const fetchUserBalance = createAsyncThunk(
    'user/fetchBalance',
    async (): Promise<Money> => {
        // TODO: catch errors
        return (await SiteApi.get('account/balance')).data;
    }
);

// TODO: fill this with more data in future
interface UserInterface {
    balance: Money;
}
interface LoadingInterface {
    isLoading: boolean;
}
interface FetchInterface extends LoadingInterface {
    isFetched: boolean;
}
interface UserSliceInterface extends FetchInterface, UserInterface {}

const currency = getUserCurrency();

const UserSlice = createSlice<UserSliceInterface, SliceCaseReducers<UserSliceInterface>>({
    name: 'user',
    initialState: {
        isLoading: false,
        isFetched: false,
        balance: {
            amount: 0,
            currency,
            formatted: formatCurrency(0, 2, currency),
        },
    },
    reducers: {
        // This is not totally ok, because we don't need formatted field
        changeBalanceBy: (state, action: PayloadAction<Money>) => {
            if (state.balance.currency !== action.payload.currency) {
                throw new Error('Cannot change use balance. Multi-currency feature is not ready yet.');
            }

            const amount = state.balance.amount + action.payload.amount;
            state.balance = {
                amount,
                currency: state.balance.currency,
                // TODO: This is temporary solution and it's invalid in log term
                formatted: formatCurrency(amount / 100, 2, state.balance.currency),
            };
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchUserBalance.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(fetchUserBalance.fulfilled, (state, action) => {
            state.balance = action.payload;
            state.isLoading = false;
            state.isFetched = true;
        });
    },
});

export const { changeBalanceBy } = UserSlice.actions;
export default UserSlice.reducer;

export const useUserBalance = function () {
    const dispatch = useDispatch();

    const { balance, isLoading, isFetched } = useGlobalStoreSelector((state) => state.user);

    useEffect(() => {
        if (!isFetched) {
            dispatch(fetchUserBalance());
        }
    }, [dispatch]);

    return {
        isLoading,
        balance,
    };
};
